export const getShopifyProductById = (id, products) => {
    return products.find((product) => product.node.variants.edges.find((item) => item.node.id === "gid://shopify/ProductVariant/" + id));
};
export const getVariantProductById = (id, products) => {
    const product = getShopifyProductById(id, products);
    const neededProduct = product.node.variants.edges.find((item) => item.node.id === "gid://shopify/ProductVariant/" + id);
    return {
        ...neededProduct,
        internal_sku: neededProduct.node.sku.value,
        productType: product.node.productType,
        title: product.node.title,
        id: product.node.id,
    };
};
export const extractIdFromGid = (gid) => {
    return parseInt(gid.split("/").pop());
};
